import { Center, LoadingOverlay } from "@mantine/core";
import { useState, useEffect, useRef } from "react";
import { getEncyptedSimulation } from "../../features/Simulations/getSimulationSlice";
import { Mixpanel } from "../../utilities/Mixpanel/MixpanelHelper";
import { WebAppEvents } from "../../utilities/Mixpanel/AnalyticeEventWebApp";
import { useMediaQuery } from "@mantine/hooks";
import { ParentPageEvents } from "../../utilities/Mixpanel/AnalyticEventParentApp";
interface ContentSimulationNewProps {
  simulationUrl: string;
}
export function ContentSimulationNew(props: ContentSimulationNewProps) {
  const iframeRef = useRef(null);
  const [isFirst, setisFirst] = useState<boolean>(true);
  const isMd = useMediaQuery(`(max-width: 800px)`);
  const [encryptedId, setEncyptedId] = useState<string>("");
  const [loadingData, setLoadingData] = useState<boolean>(true);

  function unloadSimulation() {
    if (!isFirst) {
      const iframe: any = iframeRef.current;
      if (iframe) {
        iframe.parentNode.removeChild(iframe);
      }
    } else {
      setisFirst(false);
    }
  }
  useEffect(() => {
    return () => {
      unloadSimulation();
    };
  }, []);

  return (
    <Center w={"100%"} h={"95vh"}>
      <Center w={"99%"} h={"95vh"}>
        <iframe
          src={`${props.simulationUrl}`}
          style={{
            width: "100%",
            height: "100%",
            aspectRatio: "16/9",
            border: "none",
          }}
          ref={iframeRef}
          title="Simulation"
        ></iframe>
      </Center>
    </Center>
  );
}
